import React from 'react'
import SearchBar from './SearchBar'
import Liste from './Liste'
import { Box } from '@mui/material'
import Title from '../components/Title'
import DialogAdd from './Add'

export default function Agent() {
    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>
            <Box style={{ display: "flex", justifyContent: "space-between" }} >
                {/*---------------- debut titre --------------*/}
                <Title intitule='Agent' />
                {/*---------------- fin titre --------------*/}

                {/*---------------- debut add --------------*/}
                <Box sx={{ width: "50%" }}><SearchBar /></Box>
                {/*---------------- fin add --------------*/}

                {/*---------------debut SearchBar --------- */}
                <Box><DialogAdd /></Box>
                {/* ------------------fin  SearchBar ------------*/}
            </Box>
            {/*---------------- debut Liste -----------------*/}
            <Liste />
            {/*--------------- fin Liste ------------------ */}
        </Box>
    )
}
